<template>
  <b-modal id="da-modal" size="lg" ref="da-modal" hide-footer scrollable title="Data Availability">
    <b-container>
      <b-row v-for="daData in daDataList" :key="daData.title">
        <b-col cols="12">
          <data-availability
            :uniqueName="daData.uniqueKey"
            :data="daData.data"
            :title="daData.title"
          ></data-availability>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
// Eslint disabled for the variable 'instrument_title'
/* eslint-disable camelcase */

// Eslint disabled for all lodash methods
/* eslint-disable no-undef */

// Eslint disabled for no return statement in showModal()
/* eslint-disable array-callback-return */

import { mapMutations } from 'vuex';
import axios from 'axios';
import DACalendar from './DACalendar';
import { APIBASEURL, APIDA, APIMETADATA } from '../utils/constants';

export default {
  components: {
    'data-availability': DACalendar,
  },
  data() {
    return {
      daDataList: [],
      refdes: '',
      title: '',
    };
  },
  methods: {
    show(rd, instrument_title) {
      this.refdes = rd;
      this.title = instrument_title;
      const request = {
        ref: this.refdes,
      };
      axios
        .get(`${APIBASEURL}/${APIMETADATA}/${APIDA}`, {
          params: request,
        })
        .then((resp) => {
          this.showModal(resp.data);
        });
    },
    hide() {
      this.$refs['da-modal'].hide();
    },
    showModal(data) {
      const ref = this.refdes;
      const keys = _.keys(data);
      keys.map((key) => {
        if (key.toLowerCase().includes(ref.toLowerCase())) {
          this.daDataList = [
            {
              title: this.title,
              uniqueKey: key,
              data: data[key],
            },
          ];
        }
      });
      this.$refs['da-modal'].show();
      this.setdaModalNotLoading();
    },
    ...mapMutations(['setdaModalNotLoading']),
  },
};
</script>
